import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { PRIVACY_POLICY_URL, TERMS_OF_SERVICE_URL } from '@ee/common/constants';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  /**
   * Canonical public policy URLs from the shared constant. Never hardcode these in a template —
   * they were duplicated across six files and went stale.
   */
  readonly termsOfServiceUrl = TERMS_OF_SERVICE_URL;
  readonly privacyPolicyUrl = PRIVACY_POLICY_URL;


  searchQuery = '';
  // The home page has its own hero search, so hide the compact header search there.
  isHome = true;
  readonly year = new Date().getFullYear();
  // The standalone help center is public-only; "Sign in" sends users to the portal's login (auth lives
  // in the portal — Cognito tokens aren't shared across subdomains). Shown when a portal URL is set.
  readonly portalUrl: string | undefined = (environment as Record<string, any>)['portal_url'];
  readonly authEnabled = !!this.portalUrl;

  constructor(private router: Router) {
    this.router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd)).subscribe((e) => {
      this.isHome = e.urlAfterRedirects.split('?')[0] === '/';
    });
  }

  onSearch(): void {
    const q = this.searchQuery.trim();
    if (q) {
      this.router.navigate(['/search'], { queryParams: { q } });
    }
  }

  signIn(): void {
    // Auth lives in the portal; bounce to its login page rather than running an OAuth flow here.
    if (this.portalUrl) {
      window.location.assign(`${this.portalUrl}/auth/login`);
    }
  }
}
